/**
 * Deterministic colored-square tint for a workspace (UID-140 S3, "Assign to
 * workspace" selector — `Fictiv Platform.dc.html:2433/2443` shows a small
 * colored square per workspace row). `WorkspaceSummary` (workspaces
 * vertical) carries no color field, so this picks a stable color from the
 * shared token palette by hashing the workspace id — same workspace always
 * gets the same dot color, without inventing a new "workspace color" concept
 * on the backend.
 */
const TINT_PALETTE: readonly string[] = [
  'var(--color-brand-primary)',
  'var(--color-accent-purple)',
  'var(--color-info)',
  'var(--color-warning)',
  'var(--color-success)',
  'var(--color-accent-indigo)',
]

export function workspaceTint(id: string): string {
  let hash = 0
  for (let index = 0; index < id.length; index += 1) {
    hash = (hash * 31 + id.charCodeAt(index)) >>> 0
  }
  return TINT_PALETTE[hash % TINT_PALETTE.length] ?? 'var(--color-brand-primary)'
}
